import React from 'react';
import { styles } from './ReservationStyles';

const AddEditModal = ({ formData, setFormData, onClose, onSubmit, isEdit }) => {
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  // Get today's date in YYYY-MM-DD format to disable previous dates
  const today = new Date().toISOString().split('T')[0];

  const enhancedStyles = {
    overlay: {
      ...styles.modalOverlay,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      backdropFilter: 'blur(5px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000,
    },
    content: {
      ...styles.modalContent,
      width: '95%',
      maxWidth: '500px',
      borderRadius: '20px',
      padding: '32px',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      position: 'relative',
      border: 'none',
      backgroundColor: '#fff',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '15px',
    },
    inputGroup: {
      marginBottom: '18px',
    },
    label: {
      fontSize: '13px',
      fontWeight: '700',
      color: '#6B7280',
      marginBottom: '6px',
      display: 'block',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    },
    input: {
      padding: '12px 14px',
      borderRadius: '10px',
      border: '1px solid #E5E7EB',
      fontSize: '15px',
      width: '100%',
      boxSizing: 'border-box',
      outline: 'none',
      transition: 'all 0.2s ease',
      backgroundColor: '#F9FAFB',
    },
    header: {
      margin: '0 0 25px 0',
      fontSize: '24px',
      fontWeight: '800',
      color: '#1F2937',
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end', // Aligns buttons to the right
      gap: '12px',               // Adds space between buttons
      marginTop: '25px',
    },
    submitBtn: {
      backgroundColor: '#AE7D54',
      color: 'white',
      padding: '12px 24px',
      borderRadius: '10px',
      border: 'none',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'background 0.2s',
    },
    cancelBtn: {
      backgroundColor: '#F3F4F6',
      color: '#4B5563',
      padding: '12px 24px',
      borderRadius: '10px',
      border: 'none',
      fontWeight: '600',
      cursor: 'pointer',
    }
  };

  return (
    <div style={enhancedStyles.overlay}>
      <div style={enhancedStyles.content}>
        <h2 style={enhancedStyles.header}>
          {isEdit ? 'Update Booking' : 'Create Reservation'}
        </h2>
        
        <form onSubmit={onSubmit}>
          <div style={enhancedStyles.inputGroup}>
            <label style={enhancedStyles.label}>Full Name</label>
            <input 
              type="text" 
              name="name" 
              value={formData.name || ''} 
              onChange={handleChange} 
              style={enhancedStyles.input} 
              required 
            />
          </div>

          <div style={enhancedStyles.grid}>
            <div style={enhancedStyles.inputGroup}>
              <label style={enhancedStyles.label}>Email</label>
              <input 
                type="email" 
                name="email" 
                value={formData.email || ''} 
                onChange={handleChange} 
                style={enhancedStyles.input} 
                required 
              />
            </div>
            <div style={enhancedStyles.inputGroup}>
              <label style={enhancedStyles.label}>Phone</label>
              <input 
                type="text" 
                name="phone" 
                value={formData.phone || ''} 
                onChange={handleChange} 
                style={enhancedStyles.input} 
                required 
              />
            </div>
          </div>

          <div style={enhancedStyles.grid}>
            <div style={enhancedStyles.inputGroup}>
              <label style={enhancedStyles.label}>Date</label>
              <input 
                type="date" 
                name="date" 
                min={today} // This prevents previous date selection
                value={formData.date ? new Date(formData.date).toISOString().split('T')[0] : ''} 
                onChange={handleChange} 
                style={enhancedStyles.input} 
                required 
              />
            </div>
            <div style={enhancedStyles.inputGroup}>
              <label style={enhancedStyles.label}>Time</label>
              <input 
                type="time" 
                name="time" 
                value={formData.time || ''} 
                onChange={handleChange} 
                style={enhancedStyles.input} 
                required 
              />
            </div>
          </div>

          <div style={enhancedStyles.grid}>
            <div style={enhancedStyles.inputGroup}>
              <label style={enhancedStyles.label}>Guests</label>
              <input 
                type="number" 
                name="persons" 
                value={formData.persons || 1} 
                onChange={handleChange} 
                style={enhancedStyles.input} 
                min="1" 
                required 
              />
            </div>
            <div style={enhancedStyles.inputGroup}>
              <label style={enhancedStyles.label}>Status</label>
              <select 
                name="status" 
                value={formData.status || 'New'} 
                onChange={handleChange} 
                style={enhancedStyles.input} 
                required
              >
                <option value="New">New</option>
                <option value="Reserved">Reserved</option>
                <option value="Booked">Booked</option>
                <option value="Cancelled">Cancelled</option>
              </select>
            </div>
          </div>

          <div style={enhancedStyles.footer}>
            <button type="button" style={enhancedStyles.cancelBtn} onClick={onClose}>
              Cancel
            </button>
            <button type="submit" style={enhancedStyles.submitBtn}>
              {isEdit ? 'Save Changes' : 'Confirm Reservation'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEditModal;